import $ from "jquery";
import * as Cookies from "../utils/Cookies";
import dispatcher from "./dispatcher.js";
import io from 'socket.io-client'; 

let root="https://khula.co.za/BetaAPI"
// let root="https://khula.co.za/BetaAPI"
let imageRoot="https://khula.co.za"
var API_LINK=`${root}/API/V2/ClientDashBoard/`;
var GENERAL_LINK=`${root}/API/V2/Admin/`;
var IMAGE_LINK=`${imageRoot}/ProducePic/`;
var PROFILE_IMAGE_LINK=`${imageRoot}/FarmerProfile/`;
var CLIENT_PROFILE_LINK=`${imageRoot}/ClientProfile/`;
var NODE_SERVER = "https://node.khula.co.za/"
export const socket = io.connect(NODE_SERVER,{secure:true,port:1738});
export function getActiveOrders() {
    var sendData={
        method:'POST',
        headers:new Headers({
            'Content-Type':'application/x-www-form-urlencoded'
        }),
        body:$.param({
            type:"getOngoingOrders",
            token:Cookies.checkCookie("accessToken")
        })

    };
    fetch(API_LINK,sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function(data) {
            if(data.success===1){
                dispatcher.dispatch({type: "RECEIVE_ALL_ACTIVE_ORDERS",activeOrders:$.grep( data.data,function( n, i ) {return n.state==="0";})}
                    );
            }else{
                alert(data.message);
                // logout here
            }
        });
}

export function getReadyForDelivery() {
    var sendData={
        method:'POST',
        headers:new Headers({
            'Content-Type':'application/x-www-form-urlencoded'
        }),
        body:$.param({
            type:"getOngoingOrders",
            token:Cookies.checkCookie("accessToken")
        })

    };
    fetch(API_LINK,sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function(data) {
            if(data.success===1){
                dispatcher.dispatch({type: "RECEIVE_ALL_READY_FOR_DELIVERY_ORDERS",readyOrders:$.grep( data.data,function( n, i ) {return n.state==="1";})}
                );
            }else{
                alert(data.message);
                // logout here
            }
        });
}

export function getCompletedOrders() {
    var sendData={
        method:'POST',
        headers:new Headers({
            'Content-Type':'application/x-www-form-urlencoded'
        }),
        body:$.param({
            type:"getCompletedOrders",
            token:Cookies.checkCookie("accessToken")
        })

    };
    fetch(API_LINK,sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function(data) {
            if(data.success===1){

                dispatcher.dispatch({type: "RECEIVE_ALL_COMPLETED_ORDERS",completedOrders:data.data}
                );
            }else{
                alert(data.message);
                // logout here
            }
        });
}
export function searchFarmerWithFilters(sendData) {
    fetch(API_LINK,sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function(data) {
            if(data.success===1){
                dispatcher.dispatch({type: "RECEIVE_ALL_SEARCH_FARMERS",searchFarmers:data.data}
                );
            }else{

                alert(data.message);
                // logout here
            }
        });
}
export function searchFarmer(searchText) {
    var sendData={
        method:'POST',
        headers:new Headers({
            'Content-Type':'application/x-www-form-urlencoded'
        }),
        body:$.param({
            type:"searchFarmers",
            token:Cookies.checkCookie("accessToken"),
            searchText:searchText
        })

    };
    fetch(API_LINK,sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function(data) {
            if(data.success===1){
                dispatcher.dispatch({type: "RECEIVE_ALL_SEARCH_FARMERS",searchFarmers:data.data}
                );
            }else{
                alert(data.message);
                // logout here
            }
        });
}
export function getMyPreferredFarmers() {
    var sendData={
        method:'POST',
        headers:new Headers({
            'Content-Type':'application/x-www-form-urlencoded'
        }),
        body:$.param({
            type:"getMyFarmers",
            token:Cookies.checkCookie("accessToken")
        })

    };
    fetch(API_LINK,sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function(data) {
            if(data.success===1){
                dispatcher.dispatch({type: "RECEIVE_MY_PREFERRED_FARMERS",myFarmers:data.data}
                );
            }else{
                //alert(data.message);
                // logout here
            }
        });
}

export function addToMyPreferredFarmers(farmer) {
    var sendData={
        method:'POST',
        headers:new Headers({
            'Content-Type':'application/x-www-form-urlencoded'
        }),
        body:$.param({
            type:"addPreferedSupplier",
            token:Cookies.checkCookie("accessToken"),
            farmerId: farmer.id,
        })

    };
    fetch(API_LINK,sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function(data) {
            if(data.success===1){
                dispatcher.dispatch({type: "ADD_TO_PREFERRED_FARMERS",searchFarmers:data.data,farmer:farmer}
                );
            }else{
                alert(data.message);
                // logout here
            }
        });
}

export function removeFromMyPreferredFarmers(farmerId) {
    var sendData={
        method:'POST',
        headers:new Headers({
            'Content-Type':'application/x-www-form-urlencoded'
        }),
        body:$.param({
            type:"removePreferedSupplier",
            token:Cookies.checkCookie("accessToken"),
            farmerId: farmerId
        })

    };
    fetch(API_LINK,sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function(data) {
            if(data.success===1){
                dispatcher.dispatch({type: "REMOVE_FROM_PREFERRED_FARMERS",searchFarmers:data.data,farmerId:farmerId}
                );
            }else{
                alert(data.message);
                // logout here
            }
        });
}
export function getMyProfile() {
    var sendData={
        method:'POST',
        headers:new Headers({
            'Content-Type':'application/x-www-form-urlencoded'
        }),
        body:$.param({
            type:"getMyProfile",
            token:Cookies.checkCookie("accessToken"),
        })

    };
    fetch(API_LINK,sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function(data) {
            if(data.success===1){
                dispatcher.dispatch({type: "RECEIVE_MY_PROFILE",profile:data.data}
                );
            }else{
                alert(data.message);
                // logout here
            }
        });
}
export function getMyProfileEdit() {
    var sendData={
        method:'POST',
        headers:new Headers({
            'Content-Type':'application/x-www-form-urlencoded'
        }),
        body:$.param({
            type:"getMyProfile",
            token:Cookies.checkCookie("accessToken"),
        })

    };
    fetch(API_LINK,sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function(data) {
            if(data.success===1){
                dispatcher.dispatch({type: "RECEIVE_MY_PROFILE_EDIT",profile:data.data,completed:data.completed,farmers:data.farmers,pending:data.pending}
                );
            }else{
                alert(data.message);
                // logout here
            }
        });
}
export function getAllInvoice() {
    var sendData={
        method:'POST',
        headers:new Headers({
            'Content-Type':'application/x-www-form-urlencoded'
        }),
        body:$.param({
            type:"getAllInvoices",
            token:Cookies.checkCookie("accessToken"),
        })

    };
    fetch(API_LINK,sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function(data) {
            if(data.success===1){
                dispatcher.dispatch({type: "RECEIVE_ALL_INVOICE_DETAILS",invoiceKeys:data.keys,invoiceData:data.data}
                );
            }else{
                alert(data.message);
                // logout here
            }
        });
}
export function getProduceList() {
    var sendData={
        method:'POST',
        headers:new Headers({
            'Content-Type':'application/x-www-form-urlencoded'
        }),
        body:$.param({
            type:"get_produce",
            token:Cookies.checkCookie("accessToken"),
        })

    };
    fetch(API_LINK,sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function(data) {
            dispatcher.dispatch({type: "RECEIVE_ALL_PRODUCE",produceData:data.data});
        });
}
export function getProduceListView() {
    var sendData={
        method:'POST',
        headers:new Headers({
            'Content-Type':'application/x-www-form-urlencoded'
        }),
        body:$.param({
            type:"admin_get_produce_inventory",
        })

    };

    fetch(GENERAL_LINK,sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function(data) {
            dispatcher.dispatch({type: "RECEIVE_ALL_PRODUCE_VIEW_INVENTORY",produceData:$.grep( data.data,function( n, i ) {return n.quantity!=="0";})
            });
        });
}
export function loginClient(data,remember) {
    var sendData={
        method:'POST',
        headers:new Headers({
            'Content-Type':'application/x-www-form-urlencoded'
        }),
        body:$.param(data)

    };
    fetch(API_LINK,sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function(data) {
            if(data.success===1){
                Cookies.setCookie("accessToken",data.token);
                Cookies.setCookie("rememberMe",remember);
                Cookies.setCookie("profileName",data.name);
                Cookies.setCookie("company",data.company);
                dispatcher.dispatch({type: "RECEIVE_LOGIN_SUCCESSFUL",loginData:data});
            }else{
                alert(data.message);
            }
        });
}
export function updateProfile(dataS) {
    var sendData={
        method:'POST',
        headers:new Headers({
            'Content-Type':'application/x-www-form-urlencoded'
        }),
        body:$.param(dataS)

    };
    fetch(API_LINK,sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function(data) {

            if(data.success===1){
                Cookies.setCookie("profileName",dataS.name);
                dispatcher.dispatch({type: "RECEIVE_PROFILE_UPDATE_SUCCESSFUL",residueData:dataS});
            }else{
                alert(data.message);
                // this.logoutUser()
            }
        });
}
export function logoutUser(navigator) {
    Cookies.deleteCookie("accessToken");
    Cookies.deleteCookie("rememberMe");
    Cookies.deleteCookie("profileName");
    Cookies.deleteCookie("company");
    navigator.push("/login")
}
export function updateImage(sendData) {
    fetch(API_LINK,sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function(data) {
            alert('Image Updated');
        });
}
export function performSecureRequest(body,callback,errorCallback,textShow=false) {
    body.token=Cookies.checkCookie("accessToken")
    var sendData={
        method:'POST',
        headers:new Headers({
            'Content-Type':'application/x-www-form-urlencoded'
        }),
        body:$.param(body)

    };
    fetch(API_LINK,sendData)
        .then((resp) => textShow===true?resp.text():resp.json()) // Transform the data into json
        .then(function(data) {
            console.log(data)
            if(data.success===1){
                callback(data.data)
            }else{
                errorCallback(data.message)
            }
        });

}
export function performRequest(body,callback,errorCallback) {
    var sendData={
        method:'POST',
        headers:new Headers({
            'Content-Type':'application/x-www-form-urlencoded'
        }),
        body:$.param(body)
    };
    fetch(GENERAL_LINK,sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function(data) {
            if(data.success===1){
                callback(data.data)
            }else{
                errorCallback(data.message)
            }
        });

}
export async function getMessageLines() {
    var sendData={
        method:'GET'

    };
    return new Promise((resolve,reject)=>{
        fetch(`${NODE_SERVER}messages/${Cookies.checkCookie("accessToken")}`,sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function(data) {
            if(data.success===1){
                resolve({messages:data.data})
            }else{
                reject({message:data.message});
            }
        });
    })
}
export async function getFarmerChat(farmerId) {
    var sendData={
        method:'GET'

    };
    return new Promise((resolve,reject)=>{
        fetch(`${NODE_SERVER}chat/${farmerId}/${Cookies.checkCookie("accessToken")}`,sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function(data) {
            if(data.success===1){
                resolve({messages:data.data})
            }else{
                reject({message:data.message});
            }
        });
    })
}

export function getLinkLocation() {
    return API_LINK;
}
export function getProduceImageLink() {
    return IMAGE_LINK;
}
export function getClientProfileLink() {
    return CLIENT_PROFILE_LINK;
}
export function getProfileImageLink() {
    return PROFILE_IMAGE_LINK;
}
export function isDashboard() {
    return false
}



// WEBPACK FOOTER //
// ./src/utils/Connections.js